// Reseñas de la app Revie, en cualquier página (home y productos): la app
// se usa SOLO como fuente de datos. De cada card se extraen imagen (si
// hay), rating, nombre y texto, se renderiza markup propio (.hai-review,
// estilizado en hai-home-reviews.css) y el markup original se oculta.
// Las secciones que contienen el widget se marcan con .hai-reviews-scope
// para que el CSS las cubra sin ids por página.
(() => {

  // URLs de fotos que la app trae rotas (archivos borrados de Shopify
  // Files): se recuerdan para que el re-render no vuelva a mostrar el
  // hueco mientras la imagen falla de nuevo.
  const imagenesRotas = new Set();

  const urlDe = (fondo) => (String(fondo).match(/url\(["']?(.*?)["']?\)/) || [])[1] || '';

  function getDialog() {
    let dialog = document.querySelector('.hai-review-dialog');
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.className = 'hai-review-dialog';
    dialog.innerHTML = `
      <button class="hai-review-dialog__close" type="button" aria-label="Cerrar">×</button>
      <div class="hai-review-dialog__stars"></div>
      <p class="hai-review-dialog__name"></p>
      <p class="hai-review-dialog__text"></p>
    `;
    dialog.querySelector('.hai-review-dialog__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    document.body.appendChild(dialog);
    return dialog;
  }

  function extractReview(card) {
    const text = card.querySelector('.textDet p');
    if (!text) return null;

    const media = card.querySelector('.bgImg');
    // La app movio el rating de [data-star] a <i class="rv-stars"> (jul-2026),
    // conservando la variable --rating. Se aceptan ambos: si vuelve a
    // cambiar, el fallback de 5 estrellas MIENTE sobre la nota real.
    const star = card.querySelector('[data-star], .rv-stars, [style*="--rating"]');
    const copy = text.cloneNode(true);
    copy.querySelector('b')?.remove();

    const review = {
      image: media ? media.style.backgroundImage || '' : '',
      rating: star ? parseFloat(star.style.getPropertyValue('--rating')) || 5 : 5,
      name: (text.querySelector('b')?.textContent?.trim() || 'Cliente Hai').replace(/[:：]\s*$/, ''),
      text: copy.textContent.trim(),
    };
    return review.text ? review : null;
  }

  function openDialog(review, event) {
    event.preventDefault();
    event.stopPropagation();
    const dialog = getDialog();
    const fullStars = Math.max(0, Math.min(5, Math.round(review.rating)));
    dialog.querySelector('.hai-review-dialog__stars').textContent =
      '★'.repeat(fullStars) + '☆'.repeat(5 - fullStars);
    dialog.querySelector('.hai-review-dialog__name').textContent = review.name;
    dialog.querySelector('.hai-review-dialog__text').textContent = review.text;
    dialog.showModal();
  }

  function renderReview(review) {
    const article = document.createElement('article');
    article.className = 'hai-review';

    // Cabecera (25-oct-2026): la foto del producto a la izquierda y, a su lado, estrellas y nombre; el
    // texto va debajo. Así todo parte del mismo borde interior de la tarjeta (ver hai-home-reviews.css).
    const cabeza = document.createElement('div');
    cabeza.className = 'hai-review__cabeza';
    article.appendChild(cabeza);

    const url = urlDe(review.image);
    if (url && !imagenesRotas.has(url)) {
      const media = document.createElement('div');
      media.className = 'hai-review__media';
      media.style.backgroundImage = review.image;
      cabeza.appendChild(media);

      // Varias resenas apuntan a archivos que ya no existen (404): sin esto
      // la card queda con un hueco de 110px. Al fallar se quita la imagen y
      // la celda pasa al alto compacto de "sin foto".
      const sonda = new Image();
      sonda.onerror = () => {
        imagenesRotas.add(url);
        media.remove();
        article.closest('.itemsC')?.classList.add('hai-review-cell--sin-imagen');
      };
      sonda.src = url;
    }

    const quien = document.createElement('div');
    quien.className = 'hai-review__quien';
    cabeza.appendChild(quien);

    const fullStars = Math.max(0, Math.min(5, Math.round(review.rating)));
    const stars = document.createElement('div');
    stars.className = 'hai-review__stars';
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', `Calificación: ${review.rating} de 5`);
    stars.textContent = '★'.repeat(fullStars) + '☆'.repeat(5 - fullStars);
    quien.appendChild(stars);

    const name = document.createElement('p');
    name.className = 'hai-review__name';
    name.textContent = review.name;
    quien.appendChild(name);

    const text = document.createElement('p');
    text.className = 'hai-review__text';
    text.textContent = review.text;
    article.appendChild(text);

    // Sincrónico a propósito: requestAnimationFrame puede no ejecutarse
    // nunca en pestañas en segundo plano. Con el clamp de 4 líneas, sobre
    // ~130 caracteres el texto ya puede quedar cortado.
    if (review.text.length > 130) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'hai-review__more';
      button.textContent = 'Ver más';
      button.setAttribute('aria-label', `Leer reseña completa de ${review.name}`);
      const stop = (event) => {
        event.preventDefault();
        event.stopPropagation();
      };
      button.addEventListener('pointerdown', stop);
      button.addEventListener('mousedown', stop);
      button.addEventListener('click', (event) => openDialog(review, event));
      article.appendChild(button);
    }

    return article;
  }

  function processCard(card) {
    const review = extractReview(card);
    if (!review) return;

    // La app re-aplica estilos inline (altura, etc.) despues de nuestra
    // pasada: se limpian SIEMPRE, antes del corte de idempotencia.
    if (card.getAttribute('style')) card.removeAttribute('style');

    // Idempotencia: si la app no cambió el contenido, no se re-renderiza
    // (el observer se dispara también con nuestras propias inserciones).
    const hash = review.name + '|' + review.text.slice(0, 80);
    if (card.dataset.haiHash === hash && card.querySelector(':scope > .hai-review')) return;
    card.dataset.haiHash = hash;

    card.querySelector(':scope > .hai-review')?.remove();
    Array.from(card.children).forEach((child) => {
      child.style.setProperty('display', 'none', 'important');
    });
    card.removeAttribute('style');
    card.classList.add('hai-review-cell');
    // La app marcaba con .format2/.format3 si la resena traia foto y dejo
    // de hacerlo: lo declaramos nosotros, que ya lo sabemos por los datos.
    const urlFoto = urlDe(review.image);
    card.classList.toggle('hai-review-cell--sin-imagen', !urlFoto || imagenesRotas.has(urlFoto));
    card.appendChild(renderReview(review));
  }

  function enhanceAll() {
    document.querySelectorAll('.itemsC').forEach((card) => {
      const section = card.closest('.shopify-section');
      if (section) section.classList.add('hai-reviews-scope');
      // El track se marca con clase PROPIA: el CSS colgaba de
      // #revieListCarousel y la app lo renombro a .carouselPre, con lo que
      // las cards perdieron su ancho movil y se salieron de la pantalla.
      // Anclando a lo nuestro, el proximo renombre de la app no rompe nada.
      const pista = card.parentElement;
      if (pista && !pista.classList.contains('hai-review-track')) {
        pista.classList.add('hai-review-track');
        // Con la clase cambian el relleno y el scroll-padding de la pista (el borde de la primera card pasa al
        // eje de la pagina), pero Chrome no rehace el snap que ya hizo con el relleno de la app (10 px) y la
        // primera card quedaba 10 px antes del eje (25-oct-2026). Se le pide alinear desde el comienzo.
        pista.scrollLeft = 0;
      }
      // Flechas del carrusel: la busqueda tolera el nombre de la app, pero
      // el CSS se ancla a la clase nuestra. Si la app renombra de nuevo,
      // solo cambia este selector.
      if (section) {
        section.querySelectorAll('button[class*="rv3-"]:not(.hai-review-nav__btn), button[class*="prev"]:not(.hai-review-nav__btn), button[class*="next"]:not(.hai-review-nav__btn)')
          .forEach((boton) => {
            boton.classList.add('hai-review-arrow');
            // Lado propio: la app las coloca en left/right -24px sobre un
            // contenedor a todo el ancho, o sea medio cuerpo fuera de la
            // pantalla. El CSS necesita distinguirlas para traerlas adentro.
            const nombre = boton.className.toLowerCase();
            const esPrev = nombre.includes('prev');
            if (esPrev) boton.classList.add('hai-review-arrow--prev');
            if (nombre.includes('next')) boton.classList.add('hai-review-arrow--next');
            // Icono propio. La app dejo de traer un <svg> y ahora escribe el
            // glifo "❮" como texto (sep-2026): salia en Arial 13px dentro del
            // circulo, una flecha ajena al sitio. Se conserva el boton de la
            // app (sus handlers) y solo se reemplaza el interior por un
            // chevron de linea fina, el trazo del resto de los carruseles.
            // Idempotente por DOM: si el svg ya esta, no se toca.
            if (!boton.querySelector('svg')) {
              boton.textContent = '';
              boton.setAttribute('aria-label', esPrev ? 'Reseñas anteriores' : 'Reseñas siguientes');
              boton.insertAdjacentHTML(
                'beforeend',
                '<svg class="hai-review-arrow__icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="20" height="20">' +
                  '<path d="' + (esPrev ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/>' +
                '</svg>'
              );
            }
          });

        // Navegacion propia bajo el carrusel (Andres, 09-sep-2026: las flechas
        // de la app, dos circulos flotando sobre las cards, "son horribles").
        // De 769px en adelante las de la app se ocultan por CSS y aqui se
        // agregan anterior / barra de progreso / siguiente bajo el track. El
        // track es un scroller nativo (overflow-x scroll + snap), asi que los
        // botones solo hacen scrollBy de una card y la barra lee scrollLeft.
        // Idempotente por DOM; si la app reemplaza el track, se vuelve a atar.
        const scrolly = card.parentElement && card.parentElement.parentElement;
        if (scrolly) {
          let nav = scrolly.querySelector(':scope > .hai-review-nav');
          if (!nav) {
            nav = document.createElement('div');
            nav.className = 'hai-review-nav';
            const chevron = (d) =>
              '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="18" height="18"><path d="' + d + '"/></svg>';
            nav.innerHTML =
              '<button type="button" class="hai-review-nav__btn hai-review-nav__btn--ant" aria-label="Reseñas anteriores">' + chevron('M15 5l-7 7 7 7') + '</button>' +
              '<div class="hai-review-nav__barra" aria-hidden="true"><span class="hai-review-nav__pulgar"></span></div>' +
              '<button type="button" class="hai-review-nav__btn hai-review-nav__btn--sig" aria-label="Reseñas siguientes">' + chevron('M9 5l7 7-7 7') + '</button>';
            scrolly.appendChild(nav);
            const pista = () => scrolly.querySelector('.hai-review-track');
            const paso = () => {
              const t = pista();
              const c = t && t.querySelector('.itemsC');
              if (!c) return 0;
              return c.getBoundingClientRect().width + (parseFloat(getComputedStyle(t).columnGap) || 0);
            };
            nav.querySelector('.hai-review-nav__btn--ant').addEventListener('click', () => {
              const t = pista();
              if (t) t.scrollBy({ left: -paso(), behavior: 'smooth' });
            });
            nav.querySelector('.hai-review-nav__btn--sig').addEventListener('click', () => {
              const t = pista();
              if (t) t.scrollBy({ left: paso(), behavior: 'smooth' });
            });
          }
          const track = card.parentElement;
          if (nav.haiPista !== track) {
            nav.haiPista = track;
            const pulgar = nav.querySelector('.hai-review-nav__pulgar');
            const pintar = () => {
              if (!track.isConnected) return;
              const max = track.scrollWidth - track.clientWidth;
              const frac = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
              const pos = max > 0 ? track.scrollLeft / max : 0;
              pulgar.style.width = (frac * 100) + '%';
              pulgar.style.left = (pos * (1 - frac) * 100) + '%';
              // El snap puede dejar la pista unos px antes o despues del extremo:
              // umbral de 16px en ambos extremos.
              nav.classList.toggle('hai-review-nav--inicio', track.scrollLeft <= 16);
              nav.classList.toggle('hai-review-nav--fin', max <= 0 || track.scrollLeft >= max - 16);
            };
            track.addEventListener('scroll', pintar, { passive: true });
            window.addEventListener('resize', pintar);
            pintar();
          }
        }
      }
      processCard(card);
    });
  }

  const start = () => {
    enhanceAll();
    // El widget renderiza (y a veces re-renderiza) por fetch tardío en
    // cualquier seccion: se observa el body; processCard es idempotente
    // por hash, asi que las pasadas repetidas son baratas.
    const observer = new MutationObserver(enhanceAll);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
